import { config } from '@/config.ts';

type BrandPhoneLengthConfig = Record<string, number>;

export const brandPhoneLengthMap: BrandPhoneLengthConfig = {
	default: 11,
	nomad: 11,
	ngu3: 12,
	com2: 12,
	blitz: 12,
	rockets: 12,
	rockets_vip: 12,
	sk2: 12,
	'1king': 12
};

export const getBrandPhoneLength = (): number => {
	const brand = config.BRAND || 'default';
	return brandPhoneLengthMap[brand] || brandPhoneLengthMap.default;
};
